.editor {
	display: flex;
	flex-direction: column;
	gap: var(--space-3);
}

.section {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}
/* Set off the second-and-later sections a touch from the one above. */
.section + .section {
	padding-top: var(--space-2);
	border-top: 1px dashed color-mix(in srgb, var(--ink) 12%, transparent);
}

.sectionHead {
	display: flex;
	gap: var(--space-2);
	align-items: center;
}
.heading {
	flex: 1;
	padding: var(--space-2) var(--space-3);
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
	font-weight: 600;
}
.heading:focus {
	outline: 2px solid var(--accent-sage);
	outline-offset: 1px;
}

.rows {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}
.row {
	display: flex;
	gap: var(--space-2);
	align-items: center;
}
.num {
	flex: none;
	width: 1.5rem;
	text-align: right;
	color: var(--ink-muted);
	font-variant-numeric: tabular-nums;
	font-size: 0.9rem;
}
.input {
	flex: 1;
	min-width: 0;
	padding: var(--space-3);
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
}
.input:focus {
	outline: 2px solid var(--accent-sage);
	outline-offset: 1px;
}

/* Instruction steps are short paragraphs, so the box grows with the text
   instead of scrolling a single line past the edge. `field-sizing` does that
   with no JS; where it's missing (Firefox, last I checked) `rows` leaves a
   two-line box that scrolls, which is the old behaviour with more room. */
.textarea {
	field-sizing: content;
	min-height: calc(2lh + 2 * var(--space-3) + 2px);
	resize: none;
}

/* A grown box would otherwise centre the step number and the remove button
   against its middle. Pin them to the first line: 1.5rem is the field's line
   height, the rest its padding and border. */
.rowMultiline {
	align-items: flex-start;
}
.rowMultiline .num,
.rowMultiline .iconBtn {
	height: calc(1.5rem + 2 * var(--space-3) + 2px);
}
.rowMultiline .num {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.iconBtn {
	flex: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	padding: 0;
	border: none;
	border-radius: var(--radius-md);
	background: transparent;
	color: var(--ink-muted);
	cursor: pointer;
}
.iconBtn:hover {
	background: color-mix(in srgb, var(--ink) 8%, transparent);
	color: var(--ink);
}

.addRow,
.addSection {
	align-self: flex-start;
	display: inline-flex;
	align-items: center;
	gap: var(--space-1);
	padding: var(--space-1) var(--space-2);
	border: none;
	background: transparent;
	color: var(--accent-sage);
	font: inherit;
	font-size: 0.9rem;
	cursor: pointer;
}
.addRow:hover,
.addSection:hover {
	text-decoration: underline;
}
.addSection {
	margin-top: var(--space-1);
	color: var(--ink-muted);
}
